import { useToast } from "@/contexts/ToastContext"
import { X, CheckCircle, AlertCircle, Info, AlertTriangle } from "lucide-react"

export function Toaster() {
  const { toasts, dismiss } = useToast()

  return (
    <div className="fixed top-4 right-4 z-[100] flex flex-col gap-2 w-full max-w-sm pointer-events-none">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`
            pointer-events-auto
            flex items-start gap-3 p-4 rounded-lg shadow-md border transition-opacity duration-500 animate-in fade-in-0 slide-in-from-right-4
            ${toast.type === 'error' ? 'bg-destructive text-destructive-foreground border-destructive' : 
              toast.type === 'success' ? 'bg-green-50 text-green-900 border-green-200' : 
              toast.type === 'warning' ? 'bg-yellow-50 text-yellow-900 border-yellow-200' : 
              'bg-background text-foreground border-border'}
          `}
        >
          {toast.type === 'success' && <CheckCircle className="h-5 w-5 shrink-0 text-green-600" />}
          {toast.type === 'error' && <AlertCircle className="h-5 w-5 shrink-0 text-destructive-foreground" />}
          {toast.type === 'warning' && <AlertTriangle className="h-5 w-5 shrink-0 text-yellow-600" />}
          {toast.type === 'default' && <Info className="h-5 w-5 shrink-0 text-blue-600" />}
          
          <div className="flex-1 grid gap-1">
            {toast.title && <div className="font-semibold text-sm">{toast.title}</div>}
            {toast.description && <div className="text-sm opacity-90">{toast.description}</div>}
          </div>
          
          <button
            onClick={() => dismiss(toast.id)}
            className="shrink-0 rounded-md p-1 opacity-50 hover:opacity-100 transition-opacity focus:outline-none focus:ring-2 group-hover:opacity-100"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      ))}
    </div>
  )
}
